const emailPattern = `([-!#-'*+/-9=?A-Z^-~]+(\.[-!#-'*+/-9=?A-Z^-~]+)*|"([]!#-[^-~ \t]|(\\[\t -~]))+")@[0-9A-Za-z]([0-9A-Za-z-]{0,61}[0-9A-Za-z])?(\.[0-9A-Za-z]([0-9A-Za-z-]{0,61}[0-9A-Za-z])?)+`; // https://stackoverflow.com/a/14075810
const emailRegex = new RegExp(emailPattern);

export function validateEmail(email) {
    return email && emailRegex.test(email);
}